<template>
  <div class="mutil-result-item" :style="itemRootStyle">
    <div class="role-wrap" :style="roleWrapStyle">
      <div class="role-top-bg" :style="roleImageGradientStyle"></div>
      <div class="role-image" :style="{ 'background-image': `url(${cardResult.icon_1})` }">
        <div class="linear-gradient" :style="linearGradientStyle"></div>
      </div>
      <div class="role-image-gradient" :style="roleImageGradientStyle">
        <div class="star">
          <img
            v-for="index in parseInt(cardResult.star)"
            :key="index"
            class="icon"
            src="@/assets/zs_imgs/ck-star.png"
            alt="星"
          />
        </div>
        <img class="attr" :src="formatAttr()" :alt="cardResult.attr" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MutilResultItem",
  props: {
    cardResult: { type: Object, required: true }
  },
  data() {
    return {
      icon: {
        暗: require("@/assets/zs_imgs/ck-attr-an.png"),
        风: require("@/assets/zs_imgs/ck-attr-feng.png"),
        光: require("@/assets/zs_imgs/ck-attr-guang.png"),
        火: require("@/assets/zs_imgs/ck-attr-huo.png"),
        水: require("@/assets/zs_imgs/ck-attr-shui.png")
      },
      roleWrapStyle: {},
      itemRootStyle: {},
      roleImageGradientStyle: {},
      linearGradientStyle: {}
    };
  },
  watch: {
    cardResult: {
      deep: true,
      immediate: true,
      handler(object) {
        if (parseInt(object.star) === 5) {
          this.roleWrapStyle = {
            backgroundImage: `url("${require("@/assets/zs_imgs/ck-mutil-star5-bg.png")}")`
          };
          this.itemRootStyle = {
            backgroundImage: `url("${require("@/assets/zs_imgs/ck-mutil-star5-hbg.png")}")`
          };
          this.roleImageGradientStyle = {
            backgroundImage: `url("${require("@/assets/zs_imgs/ck-mutil-star5-bg-side.png")}")`
          };
          this.linearGradientStyle = {
            background: `linear-gradient(
                          to top,
                          rgba(226, 211, 183, 1),
                          rgba(226, 211, 183, 0.8) 10px,
                          rgba(226, 211, 183, 0) 30px
                        )`
          };
        } else if (parseInt(object.star) === 4) {
          this.roleWrapStyle = {
            backgroundImage: `url("${require("@/assets/zs_imgs/ck-mutil-star4-bg.png")}")`
          };
          this.itemRootStyle = {
            backgroundImage: `url("${require("@/assets/zs_imgs/ck-mutil-star4-hbg.png")}")`
          };
          this.roleImageGradientStyle = {
            backgroundImage: `url("${require("@/assets/zs_imgs/ck-mutil-star4-bg-side.png")}")`
          };
          this.linearGradientStyle = {
            background: `linear-gradient(
                          to top,
                          rgba(180, 164, 200, 1),
                          rgba(180, 164, 200, 0.8) 10px,
                          rgba(180, 164, 200, 0) 30px
                        )`
          };
        } else {
          this.roleWrapStyle = {
            backgroundImage: `url("${require("@/assets/zs_imgs/ck-item-bg.png")}")`
          };
          this.roleImageGradientStyle = {
            backgroundImage: `url("${require("@/assets/zs_imgs/ck-item-bg-side.png")}")`
          };
          this.linearGradientStyle = {
            background: `linear-gradient(
                          to top,
                          rgba(182, 182, 180, 1),
                          rgba(182, 182, 180, 0.8) 10px,
                          rgba(182, 182, 180, 0) 30px
                        )`
          };
        }
      }
    }
  },
  methods: {
    formatAttr() {
      return this.icon[this.cardResult.attr];
    }
  }
};
</script>
<style lang="less" scoped>
.mutil-result-item {
  position: relative;
  height: 100%;
  width: 53px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  .role-wrap {
    position: absolute;
    width: 100%;
    height: 194px;
    top: 50%;
    transform: translateY(-50%);
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    .role-top-bg {
      position: absolute;
      top: 4px;
      left: 0;
      width: 54px;
      height: 48px;
      transform: rotate(180deg);
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .role-image {
      position: absolute;
      width: 51px;
      height: 136px;
      top: 50%;
      left: 1px;
      transform: translateY(-50%);
      background-size: cover;
      background-position-x: center;
      z-index: 1;
      .linear-gradient {
        position: absolute;
        width: 100%;
        height: 30px;
        bottom: 0;
      }
    }
    .role-image-gradient {
      width: 49px;
      height: 52px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      z-index: 2;
    }
    .star {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 32px;
      white-space: nowrap;
      .icon {
        width: 10px;
        height: 10px;
      }
    }
    .attr {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 12px;
      width: 20px;
      height: 20px;
      object-fit: contain;
      object-position: center;
    }
  }
}
</style>
